import { Button, DialogContent, Divider } from '@mui/material';
import AppSimpleDialog from 'app/shared-components/dialogs/AppSimpleDialog';
import { ModalComponent } from 'app/shared-components/modals/modalManager';

export const OfferAcceptConfirmModal: ModalComponent<void, boolean> = ({ open, onClose }) => {
  return (
    <AppSimpleDialog
      open={open}
      handleClose={() => onClose(false)}
      title="Are you sure you want to accept an offer?"
      size="sm"
      scroll="paper"
    >
      <Divider />
      <DialogContent className="px-24 flex flex-col items-center">
        <div className="my-16">
          <Button
            autoFocus
            onClick={() => onClose(false)}
            className="mr-9 bg-gray-100"
            sx={{
              '&.MuiButtonBase-root:hover': {
                backgroundColor: 'rgb(238, 238, 238, 1)',
              },
            }}
          >
            No
          </Button>
          <Button
            onClick={() => onClose(true)}
            className="rounded-full bg-blue-primary px-14 hover:bg-blue-primary-hover text-white"
          >
            Yes
          </Button>
        </div>
      </DialogContent>
    </AppSimpleDialog>
  );
};
